import { NgModule } from 'ng-metadata/core';
import {LocationBuilder} from './locationItemModel.service';
// import {LocationService} from './location/location.service'
import {LocationsService} from './locations.service';
import {PrmLocation} from './location/location.directive';
import {PrmLocations} from './locations.directive';
import {PrmLocationItems} from './locationItems.directive';
import {PrmLocationHoldings} from './location/locationHoldings.directive';
import {PrmStackMap} from './stackMap/stackMap.directive';
import {StackMapService} from './stackMap/stackMap.service';
import { PrmLibrary } from '../library/library.directive';

@NgModule({
    declarations: [
        PrmLocation,
        PrmLocationItems,
        PrmLocations,
        PrmLocationHoldings,
        PrmStackMap,
        PrmLibrary
    ],
    providers: [
        LocationBuilder,
        LocationsService,
        StackMapService
    ],
    imports:[

    ]
})
export class LocationsOpacModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/locations/opacLocations.module.ts